import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { MenuItem } from "@insight-models/menuItem";
import { MenuService } from "@insight-services/menu.service";
import { Observable } from "rxjs";

export const menuItemResolver: ResolveFn<Observable<MenuItem[]>> = (route, state) => {
	const menuService = inject(MenuService);
	return menuService.getTopMenuItems();
};